// extracted by mini-css-extract-plugin
export default {"referalPage":"ma1ZhN44","messageBox":"Cpe_Y3Ji","message":"O5WMRoLw","homeButton":"Az1cTMBf"};